import { useCallback } from "react";

import useClient from "hooks/useClient";

const useRejectServiceEstimate = (): {
  rejectEstimate: (optionId: string, serviceId: string, estimateId: string, userRequest: string) => Promise<number>;
} => {
  const { client } = useClient();

  const rejectEstimate = useCallback(
    async (optionId: string, serviceId: string, estimateId: string, remarks) => {
      const { status } = await client({
        method: "put",
        url: `/option/${optionId}/request-service/${serviceId}/estimate/${estimateId}/reject-estimate`,
        data: { rejectedReason: remarks },
      });
      return status;
    },
    [client]
  );

  return { rejectEstimate };
};

export default useRejectServiceEstimate;
